import { ConditionDTO } from "@/shared/endpoints/onboarding/models/dtos";

export const getConditionIdentifier = (condition: ConditionDTO) => condition.code === 'Unknown'
  ? condition.shortDescription
  : condition.code

export const constructUnknownCondition = (name: string) => ({
  code: 'Unknown',
  qualifierType: 'Unknown',
  shortDescription: name
})